export const localStorage = window.localStorage;